import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
  selector: 'app-expired-modal',
  templateUrl: './expired-modal.component.html',
  styleUrls: ['./expired-modal.component.scss'],
})
export class ExpiredModalComponent {
  @Input() redirectTo: string = '/flight';

  constructor(private activeModal: NgbActiveModal, private router: Router) {}

  onRestartSearch(): void {
    this.activeModal.close();
    this.router.navigate([this.redirectTo]);
  }
}